(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  // Contents list and in-body range card. The body is the owner's rich text,
  // so both are placed after the fact: ids are added to H2s that lack one, the
  // contents list appears only with two or more entries, and the range card is
  // cloned from its <template> to just before the third H2 (or after the first
  // block that follows the second, when there are only two).
  (function () {
    var body = document.querySelector('[data-article-body]');
    if (!body) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2')).filter(function (heading) {
      return (heading.textContent || '').trim() !== '';
    });

    var toc = document.querySelector('[data-article-toc]');
    var list = toc ? toc.querySelector('[data-article-toc-list]') : null;
    if (list && headings.length >= 2) {
      headings.forEach(function (heading) {
        var text = heading.textContent.trim();
        if (!heading.id) {
          var base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
          var id = base;
          var n = 2;
          while (document.getElementById(id)) {
            id = base + '-' + n;
            n += 1;
          }
          heading.id = id;
        }
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = text;
        item.appendChild(link);
        list.appendChild(item);
      });
      toc.hidden = false;
    }

    var template = document.querySelector('[data-article-inline-card]');
    if (!template) return;
    if (!template.content) return;
    if (headings.length < 2) return;
    if (!template.content.querySelector('.range-card')) return;

    var card = document.importNode(template.content, true);
    if (headings.length >= 3) {
      headings[2].parentNode.insertBefore(card, headings[2]);
      return;
    }
    var anchor = headings[1].nextElementSibling || headings[1];
    anchor.parentNode.insertBefore(card, anchor.nextSibling);
  })();

  // Mobile sticky bar: shown from 40% of the way down the page until the
  // "Pick your pack" links come into view, which make the same offer.
  // Hidden by CSS from tablet width up.
  (function () {
    var bar = document.querySelector('[data-range-bar]');
    if (!bar) return;

    var packs = document.querySelector('[data-article-packs]');
    var mobile = window.matchMedia('(max-width: 749px)');
    var queued = false;
    bar.hidden = false;

    function update() {
      queued = false;
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      var progress = scrollable > 0 ? window.scrollY / scrollable : 0;
      var beforePacks = packs ? packs.getBoundingClientRect().top > window.innerHeight : true;
      var show = mobile.matches && progress >= 0.4 && beforePacks;
      bar.classList.toggle('is-visible', show);
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (mobile.addEventListener) mobile.addEventListener('change', queue);
    update();
  })();

  // Copy-link button. Progressive: the button only appears when the owner enables
  // it, and if the clipboard API is unavailable the click is a no-op rather than an
  // error, so nothing breaks on browsers or contexts that refuse it.
  (function () {
    var container = document.querySelector('[data-article-share]');
    if (!container) return;

    var button = container.querySelector('[data-article-share-button]');
    var label = container.querySelector('[data-article-share-label]');
    if (!button) return;
    if (!label) return;

    var original = label.textContent;
    var timer = null;

    button.addEventListener('click', function () {
      var url = button.getAttribute('data-share-url');
      if (!url) return;
      if (!navigator.clipboard) return;

      navigator.clipboard.writeText(url).then(function () {
        label.textContent = button.getAttribute('data-copied-label') || original;
        clearTimeout(timer);
        timer = setTimeout(function () {
          label.textContent = original;
        }, 2000);
      });
    });
  })();

  // Open the comment thread when the reader was sent straight to it: either
  // Shopify's redirect after a successful post, or a #comments link from elsewhere.
  (function () {
    var thread = document.getElementById('comments');
    if (!thread) return;
    if (thread.open) return;

    var deepLinked = window.location.hash === '#comments';
    var justPosted = window.location.search.indexOf('comment_posted') !== -1;
    if (!deepLinked && !justPosted) return;

    thread.open = true;
    thread.scrollIntoView({ block: 'start' });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Sync bundle item quantities and update bundle count
  (function() {
    const bundleQuantityInputs = document.querySelectorAll('.quantity-input--bundle');
    
    bundleQuantityInputs.forEach(function(mainInput) {
      const bundleGroup = mainInput.getAttribute('data-bundle-group');
      const syncInputs = document.querySelectorAll('.quantity-input--bundle-sync[data-bundle-group="' + bundleGroup + '"]');
      const bundleCountEl = mainInput.closest('.cart-bundle')?.querySelector('.cart-bundle__count');
      
      if (bundleCountEl) {
        const bundleSocks = mainInput.closest('.cart-bundle')?.querySelectorAll('.cart-bundle__sock');
        if (bundleSocks) {
          const singular = bundleCountEl.getAttribute('data-item-singular') || 'item';
          const plural = bundleCountEl.getAttribute('data-item-plural') || 'items';
          bundleCountEl.textContent = bundleSocks.length + ' ' + (bundleSocks.length === 1 ? singular : plural);
        }
      }
      
      mainInput.addEventListener('change', function() {
        const newQuantity = this.value;
        
        syncInputs.forEach(function(syncInput) {
          syncInput.value = newQuantity;
        });
      });
    });
    
    // Handle bundle removal
    const bundleRemoveButtons = document.querySelectorAll('.btn-remove--bundle');
    bundleRemoveButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const bundleKeys = this.getAttribute('data-bundle-keys');
        if (!bundleKeys) return;
        
        const keys = bundleKeys.split(',').filter(function(key) {
          return key && key.trim().length > 0;
        });
        if (keys.length === 0) {
          return;
        }
        
        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = button.getAttribute('data-removing-text') || 'Removing...';
        
        // Build updates object for cart/update.js
        const updates = {};
        keys.forEach(function(key) {
          updates[key.trim()] = 0;
        });
        
        // Remove all bundle items using cart/update.js
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: updates
          })
        })
        .then(function(response) {
          if (!response.ok) {
            return response.text().then(function(text) {
              throw new Error('Failed to remove bundle: ' + text);
            });
          }
          return response.json();
        })
        .then(function(data) {
          // Dispatch cart updated event
          document.dispatchEvent(new CustomEvent('cart:updated'));
          // Reload the page to show updated cart
          window.location.reload();
        })
        .catch(function(error) {
          console.error('Error removing bundle:', error);
          alert(button.getAttribute('data-error-text') || 'Unable to remove bundle. Please try again.');
          button.disabled = false;
          button.textContent = originalText;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Delegated because section JavaScript is bundled once for the whole theme: the
  // listener is registered on every page, but only ever fires for a collection sort
  // control that is actually in the document.
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-collection-sort]');
    if (!select) return;

    var form = select.form;
    if (!form) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sectionId = '{{ section.id }}';
    const toggleId = 'bundle-toggle-' + sectionId;
    const contentId = 'bundle-content-' + sectionId;
    const gridId = 'bundle-grid-' + sectionId;
    const formId = 'bundle-form-' + section.id;
    const submitBtnId = 'bundle-submit-' + sectionId;
    const counterId = 'bundle-counter-' + sectionId;
    
    const toggle = document.getElementById(toggleId);
    const content = document.getElementById(contentId);
    const grid = document.getElementById(gridId);
    const form = document.getElementById(formId);
    const submitBtn = document.getElementById(submitBtnId);
    const counter = document.getElementById(counterId);
    
    if (!toggle || !content) return;
    
    // Toggle functionality
    toggle.addEventListener('click', function() {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !isExpanded);
      
      if (isExpanded) {
        content.hidden = true;
      } else {
        content.hidden = false;
      }
    });
    
    // Check for edit_bundle URL parameter - auto-expand if present
    const urlParams = new URLSearchParams(window.location.search);
    const editMode = urlParams.get('edit_bundle') === 'true';
    
    // Bundle stays closed by default - only expand if explicitly requested via edit_bundle parameter
    // if (editMode && toggle && content) {
    //   toggle.setAttribute('aria-expanded', 'true');
    //   content.hidden = false;
    // }
    
    if (!grid || !form || !submitBtn || !counter) return;
    
    const requiredItems = parseInt(form.dataset.requiredItems) || 3;
    const sellingPlanId = form.dataset.sellingPlan || '';
    const productId = form.dataset.productId;
    const variantId = form.dataset.variantId;
    
    let selectedProducts = [];
    
    if (editMode) {
      selectedProducts = [];
      updateUI();
    }
    
    // Initialize product buttons
    const productButtons = grid.querySelectorAll('.bundle-product-compact__button');
    
    productButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const productElement = button.closest('.bundle-product-compact');
        const productId = productElement.dataset.productId;
        const variantId = productElement.dataset.variantId;
        const productTitle = productElement.dataset.productTitle;
        const productImage = productElement.dataset.productImage || '';
        const productUrl = productElement.dataset.productUrl || '';
        
        toggleProduct(productId, variantId, productTitle, productElement, productImage, productUrl);
      });
    });
    
    function toggleProduct(productId, variantId, productTitle, productElement, productImage, productUrl) {
      const index = selectedProducts.findIndex(function(item) {
        return item.productId === productId;
      });
      
      if (index > -1) {
        // Deselect
        selectedProducts.splice(index, 1);
        productElement.classList.remove('selected');
      } else {
        // Select (if under limit)
        if (selectedProducts.length < requiredItems) {
          selectedProducts.push({
            productId: productId,
            variantId: variantId,
            productTitle: productTitle,
            productImage: productImage,
            productUrl: productUrl
          });
          productElement.classList.add('selected');
        }
      }
      
      updateUI();
    }
    
    function updateUI() {
      const selectedCount = selectedProducts.length;
      
      // Update counter
      if (counter) {
        counter.textContent = selectedCount + ' of ' + requiredItems + ' selected';
      }
      
      // Enable/disable submit button
      if (submitBtn) {
        submitBtn.disabled = selectedCount !== requiredItems;
      }
      
      // Enable/disable product buttons
      productButtons.forEach(function(button) {
        const productElement = button.closest('.bundle-product-compact');
        const isSelected = productElement.classList.contains('selected');
        
        if (!isSelected && selectedCount >= requiredItems) {
          button.disabled = true;
        } else {
          button.disabled = false;
        }
      });
    }
    
    // Form submission
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      if (selectedProducts.length !== requiredItems) {
        alert('Please select exactly ' + requiredItems + ' items.');
        return;
      }
      
      // Build line item properties
      const properties = {
        '_bundle_subscription': 'true'
      };
      selectedProducts.forEach(function(item, index) {
        const n = index + 1;
        properties['_bundle_item_' + n] = item.productTitle;
        properties['_bundle_image_' + n] = item.productImage || '';
        properties['_bundle_url_' + n] = item.productUrl || '';
      });
      
      // Build cart add payload
      const cartItem = {
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: properties
      };
      
      if (sellingPlanId) {
        cartItem.selling_plan = parseInt(sellingPlanId, 10);
      }
      
      // Submit to cart
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [cartItem]
        })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) {
            throw new Error(err.description || 'Failed to add to cart');
          });
        }
        return response.json();
      })
      .then(function(data) {
        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart:updated'));
        
        // Redirect to cart
        window.location.href = '/cart';
      })
      .catch(function(error) {
        console.error('Add to cart error:', error);
        alert('Error adding to cart: ' + error.message);
        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
      });
    });
    
    // Initialize UI
    updateUI();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
   * Header: the burger menu, the desktop bar's More menu and the cart icon.
   *
   * Everything is delegated from document, so it keeps working when the theme
   * editor re-renders the section.
   */
  (() => {
    'use strict';

    const DESKTOP = window.matchMedia('(min-width: 1200px)');
    const FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const routeRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* ───── Burger menu ───── */

    const openMenu = () => document.querySelector('[data-header-menu][open]');

    const focusableIn = (container) =>
      Array.from(container.querySelectorAll(FOCUSABLE)).filter((el) => el.getClientRects().length > 0);

    function closeMenu(menu, restoreFocus = true) {
      if (!menu || !menu.open) return;
      if (!restoreFocus) menu.dataset.skipFocus = 'true';
      menu.open = false;
    }

    // `toggle` does not bubble, so it is caught on the way down.
    document.addEventListener(
      'toggle',
      (event) => {
        const menu = event.target;
        if (!(menu instanceof HTMLDetailsElement) || !menu.hasAttribute('data-header-menu')) return;
        const toggle = menu.querySelector('[data-header-menu-toggle]');
        const panel = menu.querySelector('[data-header-menu-panel]');
        if (toggle) toggle.setAttribute('aria-expanded', String(menu.open));

        // A class, not an inline style: the cart drawer sets its own inline lock, and
        // the two must not clear each other.
        document.documentElement.classList.toggle('header-menu-open', menu.open);

        if (menu.open) {
          const close = menu.querySelector('.header-menu__close');
          requestAnimationFrame(() => {
            const target = close || (panel && focusableIn(panel)[0]);
            if (target) target.focus({ preventScroll: true });
          });
          return;
        }

        const skipFocus = menu.dataset.skipFocus === 'true';
        delete menu.dataset.skipFocus;
        const active = document.activeElement;
        if (!skipFocus && toggle && (!active || active === document.body || menu.contains(active))) {
          toggle.focus({ preventScroll: true });
        }
      },
      true
    );

    document.addEventListener('click', (event) => {
      const closer = event.target.closest('[data-header-menu-close]');
      if (closer) {
        closeMenu(closer.closest('[data-header-menu]'));
        return;
      }

      // A link to a spot on this page would otherwise leave the menu covering it.
      const link = event.target.closest('[data-header-menu-panel] a[href]');
      if (link && link.hash && link.pathname === window.location.pathname) {
        closeMenu(link.closest('[data-header-menu]'), false);
      }
    });

    document.addEventListener('keydown', (event) => {
      const menu = openMenu();
      if (!menu) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu(menu);
        return;
      }

      if (event.key !== 'Tab') return;
      const panel = menu.querySelector('[data-header-menu-panel]');
      if (!panel) return;
      const items = focusableIn(panel);
      if (!items.length) {
        event.preventDefault();
        return;
      }
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;
      if (!panel.contains(active)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const closeAllMenus = () => document.querySelectorAll('[data-header-menu][open]').forEach((menu) => closeMenu(menu, false));
    const onBreakpoint = (event) => {
      if (event.matches) closeAllMenus();
    };
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onBreakpoint);
    else if (DESKTOP.addListener) DESKTOP.addListener(onBreakpoint);

    document.addEventListener('cart:drawer:open', closeAllMenus);

    /* ───── More menu: closes on Escape, an outside click or focus leaving it ───── */

    const openMores = () => document.querySelectorAll('[data-header-more][open]');

    document.addEventListener('click', (event) => {
      openMores().forEach((more) => {
        if (!more.contains(event.target)) more.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      openMores().forEach((more) => {
        const hadFocus = more.contains(document.activeElement);
        more.open = false;
        const toggle = more.querySelector('summary');
        if (hadFocus && toggle) toggle.focus();
      });
    });

    document.addEventListener('focusout', (event) => {
      const more = event.target.closest && event.target.closest('[data-header-more][open]');
      if (more && event.relatedTarget && !more.contains(event.relatedTarget)) more.open = false;
    });

    /* ───── Cart icon: opens the drawer, count follows the cart ───── */

    const drawerAvailable = () => Boolean(document.querySelector('[data-cart-drawer]'));
    const opensDrawer = (link) => link && link.getAttribute('role') === 'button';

    function enhanceCartLinks(scope) {
      if (!drawerAvailable()) return;
      scope.querySelectorAll('[data-header-cart][data-drawer="true"]').forEach((link) => {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-haspopup', 'dialog');
        const drawer = document.querySelector('[data-cart-drawer]');
        if (drawer && drawer.id) link.setAttribute('aria-controls', drawer.id);
      });
    }

    function openDrawer(event) {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:drawer:open'));
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-header-cart]');
      if (!opensDrawer(link)) return;
      // Leave modified clicks alone, so "open in new tab" still reaches /cart.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      openDrawer(event);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== ' ' && event.key !== 'Spacebar') return;
      const link = event.target.closest && event.target.closest('[data-header-cart]');
      if (opensDrawer(link)) openDrawer(event);
    });

    function setCartCount(count) {
      count = Math.max(0, parseInt(count, 10) || 0);
      document.querySelectorAll('[data-header-cart]').forEach((link) => {
        const badge = link.querySelector('[data-header-cart-count]');
        const label = link.querySelector('[data-header-cart-label]');
        if (badge) {
          badge.textContent = String(count);
          badge.hidden = count === 0;
        }
        if (label) {
          const template =
            count === 0
              ? link.getAttribute('data-label-empty')
              : link.getAttribute(count === 1 ? 'data-label-one' : 'data-label-other');
          label.textContent = String(template || '').replace('[quantity]', String(count));
        }
      });
    }

    // The drawer emits this after every render, whatever triggered it.
    document.addEventListener('cart:rendered', (event) => {
      const cart = event.detail && event.detail.cart;
      if (cart) setCartCount(cart.item_count);
    });

    // Without a drawer on the page nothing else refetches, so the header does it.
    document.addEventListener('cart:updated', (event) => {
      const cart = event.detail && event.detail.cart;
      if (cart && typeof cart.item_count === 'number') {
        setCartCount(cart.item_count);
        return;
      }
      if (drawerAvailable()) return;
      fetch(`${routeRoot()}cart.js`, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          if (data) setCartCount(data.item_count);
        })
        .catch(() => {});
    });

    document.addEventListener('shopify:section:load', (event) => enhanceCartLinks(event.target));
    enhanceCartLinks(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-quiz-funnel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DESKTOP = '(min-width: 990px)';

    function playSafely(video, onRefused) {
      var playing = video.play();
      if (playing && playing.catch) {
        playing.catch(function () {
          if (onRefused) onRefused();
        });
      }
    }

    function startVideo(hero) {
      if (hero.dataset.heroVideo === 'started') return;
      if (!window.matchMedia(DESKTOP).matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (navigator.connection && navigator.connection.saveData) return;

      var template = hero.querySelector('template[data-hero-video]');
      var media = hero.querySelector('[data-hero-media]');
      if (!template || !media || !template.content.firstElementChild) return;

      hero.dataset.heroVideo = 'started';
      var video = template.content.firstElementChild.cloneNode(true);
      video.muted = true;
      video.addEventListener(
        'playing',
        function () {
          video.classList.add('is-playing');
        },
        { once: true }
      );
      media.appendChild(video);

      // Autoplay refused (Low Power Mode, a browser policy): keep the still.
      playSafely(video, function () {
        video.remove();
      });
    }

    function whenIdle(hero) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(
          function () {
            startVideo(hero);
          },
          { timeout: 3000 }
        );
      } else {
        window.setTimeout(function () {
          startVideo(hero);
        }, 200);
      }
    }

    function initHero(hero) {
      if (hero.dataset.heroReady) return;
      hero.dataset.heroReady = 'true';

      if (document.readyState === 'complete') {
        whenIdle(hero);
      } else {
        window.addEventListener(
          'load',
          function () {
            whenIdle(hero);
          },
          { once: true }
        );
      }

      // A window widened past the breakpoint gets the video; narrowed, it pauses.
      var desktop = window.matchMedia(DESKTOP);
      if (!desktop.addEventListener) return;
      desktop.addEventListener('change', function (event) {
        var video = hero.querySelector('.hero__video');
        if (event.matches) {
          if (video) {
            playSafely(video);
          } else if (document.readyState === 'complete') {
            whenIdle(hero);
          }
        } else if (video) {
          video.pause();
        }
      });
    }

    function init(root) {
      root.querySelectorAll('[data-hero]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["range-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initSpotlight(root) {
      root.querySelectorAll('[data-range-spotlight-media] video').forEach(function (video) {
        if (video.dataset.spotlightReady) return;
        video.dataset.spotlightReady = 'true';

        if (reduceMotion || !('IntersectionObserver' in window)) {
          video.controls = true;
          return;
        }

        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var playing = video.play();
              // Autoplay refused (Low Power Mode, data saver): let the visitor start it.
              if (playing && playing.catch) {
                playing.catch(function () {
                  video.controls = true;
                });
              }
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.5 }).observe(video);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initSpotlight(document);
      });
    } else {
      initSpotlight(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initSpotlight(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const recommendationsSection = document.querySelector('[data-url*="recommendations"]');
    if (!recommendationsSection) return;
    
    const url = recommendationsSection.getAttribute('data-url');
    if (!url) return;
    
    // Fetch recommendations and update the section
    fetch(url)
      .then(response => response.text())
      .then(html => {
        recommendationsSection.innerHTML = html;
      })
      .catch(error => console.error('Error loading recommendations:', error));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.sale-countdown[data-sale-end]');

    roots.forEach(function (root) {
      var endRaw = (root.getAttribute('data-sale-end') || '').trim();
      var dismissible = root.getAttribute('data-dismissible') === 'true';
      var showExpired = root.getAttribute('data-show-expired') === 'true';
      var storageKey = 'sale-countdown-dismissed:' + root.id;

      // Respect a prior dismissal for this session.
      if (dismissible) {
        try {
          if (window.sessionStorage.getItem(storageKey) === '1') {
            root.hidden = true;
            return;
          }
        } catch (e) {}
      }

      var endDate = endRaw ? new Date(endRaw.replace(' ', 'T')) : null;
      if (!endDate || isNaN(endDate.getTime())) {
        // No valid date set: hide rather than show a broken timer.
        root.hidden = true;
        return;
      }

      var inner = root.querySelector('.sale-countdown__inner');
      var expired = root.querySelector('.sale-countdown__expired');
      var elDays = root.querySelector('[data-days]');
      var elHours = root.querySelector('[data-hours]');
      var elMins = root.querySelector('[data-mins]');
      var elSecs = root.querySelector('[data-secs]');
      var closeBtn = root.querySelector('.sale-countdown__close');
      var timerId = null;

      function pad(n) {
        return (n < 10 ? '0' : '') + n;
      }

      function showExpiredState() {
        if (timerId) {
          clearInterval(timerId);
          timerId = null;
        }
        if (showExpired && expired) {
          if (inner) inner.hidden = true;
          if (closeBtn) closeBtn.hidden = true;
          expired.hidden = false;
          root.hidden = false;
        } else {
          root.hidden = true;
        }
      }

      function tick() {
        var diff = endDate.getTime() - new Date().getTime();
        if (diff <= 0) {
          if (elDays) elDays.textContent = '00';
          if (elHours) elHours.textContent = '00';
          if (elMins) elMins.textContent = '00';
          if (elSecs) elSecs.textContent = '00';
          showExpiredState();
          return;
        }

        var totalSecs = Math.floor(diff / 1000);
        var days = Math.floor(totalSecs / 86400);
        var hours = Math.floor((totalSecs % 86400) / 3600);
        var mins = Math.floor((totalSecs % 3600) / 60);
        var secs = totalSecs % 60;

        if (elDays) elDays.textContent = pad(days);
        if (elHours) elHours.textContent = pad(hours);
        if (elMins) elMins.textContent = pad(mins);
        if (elSecs) elSecs.textContent = pad(secs);

        // The bar renders visible by default; nothing to reveal here. We only
        // ever flip it hidden for dismissed / invalid / expired states, so a live
        // countdown paints on first paint (no display:none -> display flip that
        // mobile Safari can fail to repaint until a later reflow).
      }

      if (dismissible && closeBtn) {
        closeBtn.addEventListener('click', function () {
          root.hidden = true;
          try {
            window.sessionStorage.setItem(storageKey, '1');
          } catch (e) {}
        });
      }

      tick();
      // Keep ticking only while the bar is live (tick() hides it on expiry).
      if (!root.hidden) {
        timerId = setInterval(tick, 1000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.ugc-grid');

    sections.forEach(function(section) {
      var sectionId = section.id.replace('ugc-grid-', '');
      var dialog = document.getElementById('ugc-lightbox-' + sectionId);
      var dataEl = section.querySelector('[data-ugc-data="' + sectionId + '"]');
      if (!dialog || !dataEl) return;

      var items;
      try {
        items = JSON.parse(dataEl.textContent);
      } catch(e) {
        return;
      }

      var mediaContainer = dialog.querySelector('.ugc-grid__lightbox-media');
      var authorEl = dialog.querySelector('.ugc-grid__lightbox-author');
      var captionEl = dialog.querySelector('.ugc-grid__lightbox-caption');
      var closeBtn = dialog.querySelector('.ugc-grid__lightbox-close');

      function openLightbox(index) {
        var item = items[index];
        if (!item) return;
        if (item.video) return;

        mediaContainer.innerHTML = '';
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.alt;
        mediaContainer.appendChild(img);

        authorEl.textContent = item.author;
        if (item.caption) {
          captionEl.textContent = item.caption;
          captionEl.style.display = '';
        } else {
          captionEl.textContent = '';
          captionEl.style.display = 'none';
        }

        dialog.showModal();
      }

      function closeLightbox() {
        var video = mediaContainer.querySelector('video');
        if (video) video.pause();
        dialog.close();
      }

      function playVideoInPlace(btn, index) {
        var item = items[index];
        if (!item || !item.video) return;
        var media = btn.querySelector('.ugc-grid__media');
        if (!media) return;
        var existing = media.querySelector('.ugc-grid__inline-video');
        if (existing) {
          existing.play();
          return;
        }
        var video = document.createElement('video');
        video.className = 'ugc-grid__inline-video';
        video.src = item.video;
        if (item.image) video.poster = item.image;
        video.controls = true;
        video.muted = true;
        video.playsInline = true;
        video.preload = 'metadata';
        media.classList.add('ugc-grid__media--playing');
        media.appendChild(video);
        video.play();
      }

      section.querySelectorAll('.ugc-grid__item').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var index = parseInt(btn.getAttribute('data-ugc-index'), 10);
          if (items[index] && items[index].video) {
            playVideoInPlace(btn, index);
            return;
          }
          openLightbox(index);
        });
      });

      closeBtn.addEventListener('click', closeLightbox);

      dialog.addEventListener('click', function(e) {
        if (e.target === dialog) closeLightbox();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
